(function () {
  'use strict';
  if (window.STMNPatchPreview) { window.STMNPatchPreview.init(); return; }
  var ns = 'http://www.w3.org/2000/svg';
  // Coordinates refer to the original 1440 × 1717 front photographs, not the viewport.
  // Each patch has its own fixed slot, clear of seams, zips and the existing bag branding.
  var models = {
    'zaino-x-line-40-litri': {

      slots: [[645, 930, 75], [755, 950, 170], [755, 1090, 185], [640, 1050, 94]]
    },
    'zaino-borsone-x-line-50-litri': {

      slots: [[460, 500, 84], [590, 495, 175], [585, 565, 185], [820, 493, 110]]
    },
    'zaino-nomatec-30-35-litri': {

      slots: [[445, 1200, 80], [570, 1200, 175], [565, 1265, 185], [810, 1190, 108]]
    },
    // Tactical Light 30 L (foto 1888 x 2254, stesso rapporto): patch sulle due strisce di velcro della tasca superiore
    'zaino-tactical-light-30-litri-nero': {
      slots: [[480, 452, 70], [565, 466, 170], [560, 618, 185], [760, 455, 80]]
    },
    'zaino-tactical-light-30-litri-verde': {
      slots: [[480, 452, 70], [565, 466, 170], [560, 618, 185], [760, 455, 80]]
    }
  };
  // Alpha bounds of the configured transparent artwork, on its 180 × 215 canvas.
  var artwork = [
    {handle: 'patch-logo', crop: [42, 44, 94, 121]},
    {handle: 'patch-stmn', crop: [19, 81, 142, 41]},
    {handle: 'patch-competitor-dept', crop: [14, 81, 154, 46]},
    {handle: 'patch-zero-slim', crop: [45, 43, 105, 111]}
  ];
  var state = null, mounts = [], pending = false, lastOpener = null;
  function svgElement(name, attrs) {
    var node = document.createElementNS(ns, name);
    Object.keys(attrs || {}).forEach(function (key) { node.setAttribute(key, attrs[key]); });
    return node;
  }
  function photoName(src) {
    try { return new URL(src, location.href).pathname.split('/').pop(); } catch (e) { return ''; }
  }
  function layer() {
    var group = svgElement('g', {'data-patch-layer': ''});
    artwork.forEach(function (art, index) {
      var option = state.picker.querySelector('[data-patch-handle="' + art.handle + '"]');
      var image = option && option.querySelector('img');
      if (!image) return;
      var slot = state.model.slots[index];
      var patch = svgElement('svg', {
        x: slot[0], y: slot[1], width: slot[2], height: slot[2] * art.crop[3] / art.crop[2],
        viewBox: art.crop.join(' '), preserveAspectRatio: 'xMidYMid meet',
        'data-patch-on-photo': art.handle, overflow: 'hidden', 'aria-hidden': 'true'
      });
      patch.style.display = 'none';
      patch.appendChild(svgElement('image', {href: image.getAttribute('src'), width: 180, height: 215, preserveAspectRatio: 'none'}));
      group.appendChild(patch);
    });
    return group;
  }
  function sizeMount(entry) {
    if (!entry.image.isConnected) return;
    var image = entry.image, parent = image.parentElement;
    var ir = image.getBoundingClientRect(), pr = parent.getBoundingClientRect();
    var style = entry.overlay.style;
    style.left = (ir.left - pr.left + parent.scrollLeft - parent.clientLeft) + 'px';
    style.top = (ir.top - pr.top + parent.scrollTop - parent.clientTop) + 'px';
    style.width = ir.width + 'px';
    style.height = ir.height + 'px';
    entry.overlay.setAttribute('preserveAspectRatio', getComputedStyle(image).objectFit === 'cover' ? 'xMidYMid slice' : 'xMidYMid meet');
  }
  function mount(image) {
    if (mounts.some(function (entry) { return entry.image === image; })) return;
    var parent = image.parentElement;
    if (getComputedStyle(parent).position === 'static') parent.style.position = 'relative';
    var overlay = svgElement('svg', {
      viewBox: '0 0 1440 1717', 'data-patch-overlay': '',
      class: 'stmn-patch-photo-overlay', 'aria-hidden': 'true', focusable: 'false'
    });
    overlay.appendChild(layer());
    parent.appendChild(overlay);
    var entry = {image: image, overlay: overlay};
    mounts.push(entry);
    image.addEventListener('load', function () { sizeMount(entry); });
    if (window.ResizeObserver) {
      entry.resize = new ResizeObserver(function () { sizeMount(entry); });
      entry.resize.observe(image);
    }
    sizeMount(entry);
  }
  function update() {
    if (!state || !state.picker.isConnected) return;
    mounts = mounts.filter(function (entry) {
      if (entry.image.isConnected) return true;
      if (entry.resize) entry.resize.disconnect();
      return false;
    });
    document.querySelectorAll('.mp__gallery-slide > img, .mp__slide > img, #mp-fullscreen > img').forEach(function (image) {
      if (photoName(image.getAttribute('src')) === state.photo) mount(image);
    });
    var selected = Array.from(state.picker.querySelectorAll('[data-stmn-patch-choice][aria-pressed="true"]'));
    var handles = selected.map(function (option) { return option.dataset.patchHandle; });
    document.querySelectorAll('[data-patch-on-photo]').forEach(function (patch) {
      var show = handles.indexOf(patch.getAttribute('data-patch-on-photo')) !== -1;
      if (patch.style.display !== (show ? '' : 'none')) patch.style.display = show ? '' : 'none';
    });
    var description = handles.length ? 'Zaino intero con patch ' + selected.map(function (option) { return option.dataset.name; }).join(', ') + ' sul pannello in velcro' : 'Zaino intero, senza patch selezionate';
    if (state.detail.getAttribute('aria-label') !== description) state.detail.setAttribute('aria-label', description);
    var fullscreen = document.getElementById('mp-fullscreen');
    if (fullscreen) {
      fullscreen.setAttribute('role', 'dialog');
      fullscreen.setAttribute('aria-modal', 'true');
      fullscreen.setAttribute('aria-label', 'Anteprima zaino e patch');
      var close = fullscreen.querySelector('button');
      if (close) {
        close.setAttribute('aria-label', 'Chiudi anteprima');
        if (!fullscreen.dataset.patchFocus) { fullscreen.dataset.patchFocus = 'true'; close.focus({preventScroll: true}); }
      }
    } else if (lastOpener) {
      lastOpener.focus({preventScroll: true}); lastOpener = null;
    }
    mounts.forEach(sizeMount);
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; update(); });
  }
  function showFront() {
    var index = Number(state.preview.dataset.patchPhotoIndex);
    if (typeof window.mpGallerySelect === 'function') window.mpGallerySelect(index);
    if (typeof window.mpScrollTo === 'function') window.mpScrollTo(index);
    schedule();
  }
  function init() {
    var preview = document.querySelector('[data-patch-preview]');
    if (!preview || (state && state.preview === preview)) return;
    var model = models[preview.dataset.patchModel];
    if (!model) return;
    mounts.forEach(function (entry) { if (entry.resize) entry.resize.disconnect(); entry.overlay.remove(); });
    mounts = [];
    state = {preview: preview, picker: preview.closest('[data-stmn-patch-picker]'), model: model, photo: photoName(preview.dataset.patchPhoto), detail: preview.querySelector('[data-patch-detail]')};
    state.detail.setAttribute('viewBox', '0 0 1440 1717');
    state.detail.appendChild(layer());
    preview.hidden = false;
    state.picker.classList.add('stmn-patches--photo');
    update();
  }
  document.addEventListener('click', function (event) {
    if (!state) return;
    var option = event.target.closest('[data-stmn-patch-choice]');
    if (option && state.picker.contains(option) && !option.disabled) {
      // The price/selection handler runs independently; read its final state after the click.
      queueMicrotask(function () { update(); showFront(); });
    }
    var opener = event.target.closest('[data-patch-preview-open]');
    if (opener && typeof window.mpToggleFullscreen === 'function') {
      lastOpener = opener; showFront(); window.mpToggleFullscreen(); update();
    }
  });
  document.addEventListener('keydown', function (event) {
    var fullscreen = document.getElementById('mp-fullscreen');
    if (!state || !fullscreen) return;
    if (event.key === 'Escape' && typeof window.mpCloseFullscreen === 'function') { window.mpCloseFullscreen(); schedule(); }
    if (event.key === 'Tab') { event.preventDefault(); fullscreen.querySelector('button')?.focus(); }
  });
  document.addEventListener('stmn:variant-changed', schedule);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', schedule);
  new MutationObserver(function (records) {
    if (records.some(function (record) {
      return Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(function (node) {
        return node.nodeType === 1 && (node.id === 'mp-fullscreen' || node.matches?.('#mp-fullscreen > img'));
      });
    })) schedule();
  }).observe(document.body, {childList: true, subtree: true});
  window.STMNPatchPreview = {init: init};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
